import Image from '../ui/Image/Image'
import { getUrl } from '../../utils'
import styles from './Banner.module.scss'
import playIcon from '../../assets/images/playOrange.svg'

function Banner({ widgetDetails }) {
  const {
    pagetitle: heading,
    description,
    button,
    backgroundvideo,
  } = widgetDetails

  return (
    <div className={styles.container}>
      {backgroundvideo?.url && (
        <video
          src={getUrl(backgroundvideo)}
          autoPlay
          loop
          muted
          className={styles.video}
          playsInline
          controlsList="nodownload noremoteplayback"
        >
          {/* <source  type={backgroundvideo.type} /> */}
          Your browser does not support the video tag.
        </video>
      )}
      <div className={styles.content}>
        <h1 className={styles.header}>
          {heading.startText}
          <span className={styles.highlight}>{heading.highlightedText}</span>
          {heading.endText}
        </h1>
        <p className={styles.subHeader}>{description}</p>
        {/* <button aria-label={button?.label} className={styles.button}>
          {button.label}
          <Image
            src={playIcon}
            alt={'play banner'}
            className={styles.playButton}
          />
        </button> */}
      </div>
    </div>
  )
}

export default Banner
